import { createFileRoute } from '@tanstack/react-router';
import { BroadcastJourneyMetricsRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/journey_metrics',
)({
  component: BroadcastJourneyMetricsRouteView,
});
